import { render, staticRenderFns } from "./epic_issue_actions_split_button.vue?vue&type=template&id=20470c2e&"
import script from "./epic_issue_actions_split_button.vue?vue&type=script&lang=js&"
export * from "./epic_issue_actions_split_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports